import { z } from 'zod';

/** Lifecycle of a method version (00-ARCHITECTURE §3). */
export const METHOD_STATUSES = ['DRAFT', 'IN_REVIEW', 'PUBLISHED'] as const;
export const MethodStatusSchema = z.enum(METHOD_STATUSES);
export type MethodStatus = z.infer<typeof MethodStatusSchema>;

/** How much of an activity an agent carries in an agentic variant. */
export const AUTOMATION_LEVELS = ['assisted', 'augmented', 'autonomous-with-approval'] as const;
export const AutomationLevelSchema = z.enum(AUTOMATION_LEVELS);
export type AutomationLevel = z.infer<typeof AutomationLevelSchema>;

/** Adoption-workshop verdict per element. */
export const TAILORING_DECISIONS = ['INCLUDE', 'ADAPT', 'SKIP'] as const;
export const TailoringDecisionValueSchema = z.enum(TAILORING_DECISIONS);
export type TailoringDecisionValue = z.infer<typeof TailoringDecisionValueSchema>;

export const MCP_TRANSPORTS = ['stdio', 'http', 'sse'] as const;
export const McpTransportSchema = z.enum(MCP_TRANSPORTS);
export type McpTransport = z.infer<typeof McpTransportSchema>;

/** A Role is one type discriminated by kind, never two hierarchies (§3). */
export const ROLE_KINDS = ['HUMAN', 'AGENT'] as const;
export type RoleKind = (typeof ROLE_KINDS)[number];
